<template>
  <div class="has-header has-footer header_toped">
    <div class="container-style pos_changed">
      <studyFeatureHeader></studyFeatureHeader>
      <div class="pl-20 pr-20">
        <!--TUR-61129 Start-->
        <div class="row" v-if="!isStudyOpenEnrollment">
          <div class="row section_heading">
            Participant verification settings
            <p class="m-0 fs-14 color_slate-grey fw-normal mt-5 text-normalize">
              Select the method in which participants will register and sign in.
            </p>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12 pl-0">
              <div class="col-lg-4 col-md-6 col-sm-5 col-xs-5 pt-2 pl-0 fw-normal mt-5">
                Verification Method
                <span
                  ><i
                    class="fa fa-info-circle help_icon cursor_pointer"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="0"
                    data-trigger="focus"
                    data-content="This setting identifies the study's method for registering and authenticating the participant's identity. When the Both (Email and Phone) option is selected, the participant's method will be chosen when they are added to the study. When Phone Only is selected, the participant will need to verify their identify via SMS (text). When Phone Only or Email Only is selected, the Verification Method will not display on the Participant Profile page."
                    data-html="true"
                  ></i
                ></span>
              </div>
              <div class="col-lg-4 col-md-5 col-sm-5 col-xs-4 p-0 verify_method">
                <CustomFormSelect :options="verificationOptions" v-model="selectedVerificationMethod" v-on:change="changeVerificationMethod" class="form-control"> </CustomFormSelect>
              </div>
            </div>
          </div>
        </div>
        <!-- Datavant Tokenization Section - Starts -->
        <div v-if="datavantEnabledInStudy">
        <div class="section_heading">
          Datavant Tokenization
            <p class="m-0 fs-14 color_slate-grey fw-normal mt-5 text-normalize box-sizing"> 
              Tokenization is the process of replacing sensitive data with unique identification symbols that retain all the essential information about the data without <br> compromising its security. The non-sensitive, replacement information is called a token.
            </p>
            <p class="sub-heading m-0" v-if="!isDatavantTokenizationEnabled">
              To complete the tokenization process, you will first need the Configuration Name and Data Set Name from Datavant.
            </p>
        </div>
        <div class="row field_row">
            <div class="col-lg-1 col-md-2 col-sm-1 col-xs-1 p-0 w-45">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="isDatavantTokenizationEnabled"
                  v-on:change="toggleDatavantTokenization()"
                  :disabled="!isDatavantToggleEditable"
                />
                <div class="slider round"></div>
              </label>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 pt-2 pl-0 fw-500 item_field_space">
              <span>Enable Tokenization</span>
              <span class="edit-datavant-token" v-if="isDatavantTokenizationEnabled" @click="openDatavantTokenListModal()">Edit</span>
            </div>
          </div>
            <div class="row field_row" v-if="isDatavantTokenizationEnabled">
                  <div class=" pl-0 fw-500 item_field_space full-width">
                      <div class="token-details">
                        <span class="token-label ml-45">Core Tokens: 
                          <span class="token-value">{{ getCoreTokenCount }}</span>
                        </span>
                        <span class="token-label ml-40">Standard Tokens: 
                          <span class="token-value">{{ getStandardTokenCount }}</span>
                        </span>
                        <span class="token-label ml-40">Configuration Name:  
                          <span class="token-value">{{ configurationFileName }}</span>
                        </span>
                        <span class="token-label ml-40">Data Set Name:  
                          <span class="token-value">{{ datasetName }}</span>
                        </span>
                      </div>
                  </div>
            </div>
        </div>
        <!-- Datavant Tokenization Section - Ends -->
         <!--TUR-61129 End-->
        <div class="row">
          <div v-for="(item, index) in personalInfoArray" :key="item.key">
            <b-popover
              :target="`requiredForDatavant-${item.key}-${index}`"
              triggers="hover blur"
              placement="bottom-right"
              :boundary="'viewport'"
              v-if="item['requiredForDatavant']">
              <div>
                This field is required based on a token that was selected. To change, edit selected Datavant tokens above
              </div>
            </b-popover>
            <div class="row section_heading" v-if="index === 0">
              Participant Information
              <p class="m-0 fs-14 color_slate-grey fw-normal mt-5 text-normalize">
                Select the fields your participant will provide during the registration process.
              </p>
            </div>
            <div
              :style="{
                display: (item.key == 'userName' && (!pwebCognitoAuthentication || pwebCognitoAuthentication === false)) || (item.key == 'verificationPhone' && isStudyOpenEnrollment) ? 'none' : 'block'
              }"
              class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0"
            >
              <div class="row field_row">
                <div class="col-lg-1 col-md-2 col-sm-1 col-xs-1 p-0">
                  <div :id="`requiredForDatavant-${item.key}-${index}`">
                    <label class="switch" :class="{'inactive': (item.isOptional === 'required' || item.key === 'verificationPhone' || item.key === 'password' || item.key === 'userName' || item.disableForDatavant)}" >
                      <input
                        type="checkbox"
                        v-model="item.isVisible"
                        :disabled="item.isOptional === 'required' && (item.index === 3 || item.index === 4) || (item.key === 'email' && selectedVerificationMethod === 'phone')"
                        v-on:change="changeVisibility(item)" 
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 pt-2 pl-0 fw-500 item_field_space" :class="{ 'text-capitalize': item.key != 'howDidYouHear' }">
                  {{ item.field }}
                  <span v-if="item.key === 'email'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="Participants will register or login with their email address for platform environments not authenticating with usernames for login. An email address can be used for study related communications and to verify a participant's identity when their Verification Method is equal to Email."
                      data-html="true"
                    ></i>
                  </span>
                  <span v-if="item.key === 'userName'">
                    <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content=" Participants will register and sign in using this unique identifier for all required platform environments." data-html="true"></i>
                  </span>
                  <span v-if="item.key === 'phoneNumber'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="This mobile phone number is the primary contact number for study related communications and SMS (texts), if enabled/permitted. It may be the same or different than the participant's verification phone number, when the phone verification method is configured for the participant."
                      data-html="true"
                    ></i>
                  </span>
                  <span v-if="item.key === 'verificationPhone'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="When the study's Verification Method is set to Phone Only or Both (Email and Phone), this mobile phone number will be used to authenticate a participant's identity via SMS (text) at each login. This field will not be available for participants configured with a Verification Method of Email."
                      data-html="true"
                    ></i>
                  </span>
                  <span v-if="item.key === 'password'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="The participants password will be compliant with security and privacy requirements including the following: <br />
                    1. 	minimum 8 characters <br />
                    2. 	at least 1 upper case letter <br />
                    3. 	at least 1 lower case character <br />
                    4. 	at least 1 number <br />
                    5. 	at least 1 symbol (e.g. @#$%) <br />
                    6. 	Must not have a repetitive string (e.g. abc12abc12…)"
                      data-html="true"
                    ></i>
                  </span>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-5 col-xs-4 p-0">
                  <select
                    class="form-control custom-font"
                    v-model="item.isOptional"
                    :disabled="( !item.isVisible || (item.key === 'email' && selectedVerificationMethod === 'phone') && (item.key === 'verificationPhone' || selectedVerificationMethod === 'email') ) || item['requiredForDatavant'] || item.disableForDatavant"
                    v-if="(item.key !== 'email' && item.key !== 'password' && item.key !== 'userName' && item.key !== 'verificationPhone')"
                  >
                    <option value="default" disabled>Select Requirement</option>
                    <option value="optional">Optional field</option>
                    <option value="required">Required field</option>
                  </select>
                   <div v-if="item.isVisible && item.field === 'Birth Date'" :class="{'disabled-for-datavant': item['requiredForDatavant']}">
                    <label class="formate-class">Format:</label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="birthDate" class="radio-box" />
                      M/D/Y
                    </label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="dobWithMonthYear" class="radio-box" />
                      M/Y
                    </label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="dobWithYear" class="radio-box" />
                      Y
                    </label>
                  </div>
                  <div class="optionalField" v-if="item.key === 'email' || item.key === 'password' || item.key === 'userName' || item.key === 'verificationPhone'">
                    <span v-if="item.isVisible" class="text-capitalize">{{ item.isOptional }} field</span>
                    <span v-else class="text-capitalize">Not Captured</span>
                  </div>
                </div>
              </div>
              <div class="row" v-if="item.key === 'gender'">
                <div class="radio col-lg-11 p-0 col-lg-offset-1 col-md-11 col-md-offset-1 col-sm-12 col-xs-12 clearfix">
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      id="gender_standard"
                      value="standard"
                      v-model="item.meta"
                      :disabled="!item.isVisible || item['requiredForDatavant']"
                    />
                    <span class>Standard Gender Selection List</span>
                  </label>
                  <i
                    class="fa fa-info-circle help_icon cursor_pointer"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="0"
                    data-trigger="focus"
                    data-content="<b> Standard Gender Selection List </b><br />
                    • 	Male  <br />
                    • 	Female <br />
                    •   Other gender identity <br />&nbsp; &nbsp;(when selected, opens to a free form &nbsp;&nbsp;&nbsp;field)"
                    data-html="true"
                  ></i>
                </div>
                <div class="custom-control custom-radio radio col-lg-11 p-0 col-lg-offset-1 col-md-offset-1 col-md-11 col-sm-12 col-xs-12 clearfix">
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      id="gender_extended"
                      value="extended"
                      v-model="item.meta"
                      :disabled="!item.isVisible || item['requiredForDatavant']"
                    />
                    <span class>Expanded Gender Selection List</span>
                  </label>
                  <i
                    class="fa fa-info-circle help_icon cursor_pointer"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="1"
                    data-trigger="focus"
                    data-content="<b> Expanded Gender Selection List </b><br />
                        • 	Man <br />
                        • 	Woman <br />
                        • 	Genderqueer <br />
                        • 	Transgender Man (Female-to-Male) <br />
                        • 	Transgender Woman (Male-to- &nbsp;&nbsp;&nbsp;Female) <br />
                        • 	Another gender identity (when  &nbsp;&nbsp;&nbsp;selected, opens to a free form field)"
                    data-html="true"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Custom Fields-->
        <div>
          <div>
            <span class="custom-title"
              >Custom Fields
              <i class="fa fa-info-circle custom_icon_grey cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content="Custom fields are meant to collect additional information from participants. They are considered PII." data-html="true"></i>
            </span>
          </div>
          <div v-if="!!customFieldArray && customFieldArray.length > 0">
            <div class="row mt-12" v-for="(item, index) in customFieldArray" :key="index">
              <div class="col-lg-1 col-md-2 col-sm-1 col-xs-1 p-0 mt-8">
                <label class="switch">
                  <input type="checkbox" v-model="item.isVisible" />
                  <div class="slider round"></div>
                </label>
              </div>
              <div class="col-lg-3 col-md-2 col-sm-1 col-xs-1 p-0">
                <input type="text" class="custom-field-input" v-model="item.field" placeholder="Enter Custom Field" maxlength="100" />
              </div>
              <div class="col-lg-3 col-md-2 col-sm-1 col-xs-1 p-0" :class="{ 'mr-15': !isMultiCountry }">
                <select class="form-control custom-field-margin custom-field-drop" v-model="item.isOptional">
                  <option value="default">Select Requirement</option>
                  <option value="optional">Optional field</option>
                  <option value="required">Required field</option>
                </select>
              </div>
              <div class="col-lg-4 col-md-2 col-sm-1 col-xs-1 p-0 ml-8 mt-10" v-if="isMultiCountry">
                <span class="custom-select-country" data-toggle="modal" @click="customFieldCountries(item, index)">Select Countries</span>
                <span class="number-badge">{{ item.expectedCountries.length }}</span>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-1 col-xs-1 p-0 ml-8">
                <div class="color_red pt-10 cursor_pointer" @click="removeCustumField(item.key)">
                  Remove
                </div>
              </div>
            </div>
          </div>
          <div v-if="!!customFieldArray && customFieldArray.length > -1 && customFieldArray.length < 3" class="row">
            <div>
              <button class="add-custom-filed" :class="{ addCustomFiledBlur: isCustomFiledsValid }" :disabled="isCustomFiledsValid" @click="addCustomFiled()">
                + Add Custom Field
              </button>
            </div>
          </div>
        </div>
        <!--Contact Info-->
        <div class="row">
          <div v-for="(item, index) in contactInfoArray">
            <b-popover
              :target="`requiredForDatavant-${item.key}-${index}`"
              triggers="hover blur"
              placement="bottom-right"
              :boundary="'viewport'"
              v-if="item['requiredForDatavant']">
              <div>
                This field is required based on a token that was selected. To change, edit selected Datavant tokens above
              </div>
            </b-popover>
            <div class="row section_heading" v-if="index === 0">Contact details</div>
            <div :style="{display: (item.key=='userName' && (!pwebCognitoAuthentication || pwebCognitoAuthentication===false))?'none':'block'}" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0">
              <div class="row field_row">
                <div class="col-lg-1 col-md-2 col-sm-1 col-xs-1 p-0">
                  <div :id="`requiredForDatavant-${item.key}-${index}`">
                    <label
                      class="switch"
                      :class="{'inactive': (item.isOptional === 'required' && (item.key === 'email' || item.key === 'password' || item.key === 'userName')), 'disabled-for-datavant': item['requiredForDatavant']}"
                    >
                      <input
                        type="checkbox"
                        v-model="item.isVisible"
                        :disabled="item.isOptional === 'required' && (item.index === 3 || item.index === 4)"
                        v-on:change="changeVisibility(item)"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 pt-2 pl-0 fw-500 item_field_space">
                  {{ item.field }}
                  <span v-if="item.key === 'email'">
                    <i class="fa fa-question-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content="Participants will register or login with their email address." data-html="true"></i>
                  </span>
                  <span v-if="item.key === 'userName'">
                    <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content=" Participants will register and sign in using this unique identifier for all required platform environments." data-html="true"></i>
                  </span>
                  <span v-if="item.key === 'phoneNumber'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="This mobile phone number is the primary contact number for study related communications and SMS (texts), if enabled/permitted. It may be the same or different than the participant's verification phone number, when the phone verification method is configured for the participant."
                      data-html="true"
                    ></i>
                  </span>
                  <span v-if="item.key === 'verificationPhone'">
                    <i
                      class="fa fa-info-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="When the study's Verification Method is set to Phone Only or Both (Email and Phone), this mobile phone number will be used to authenticate a participant's identity via SMS (text) at each login. This field will not be available for participants configured with a Verification Method of Email."
                      data-html="true"
                    ></i>
                  </span>
                  <span v-if="item.key === 'password'">
                    <i
                      class="fa fa-question-circle help_icon cursor_pointer"
                      aria-hidden="true"
                      data-toggle="popover"
                      tabindex="0"
                      data-trigger="focus"
                      data-content="The participants password will be compliant with security and privacy requirements including the following: <br />
                    1. 	minimum 8 characters <br />
                    2. 	at least 1 upper case letter <br />
                    3. 	at least 1 lower case character <br />
                    4. 	at least 1 number <br />
                    5. 	at least 1 symbol (e.g. @#$%) <br />
                    6. 	Must not have a repetitive string (e.g. abc12abc12…)"
                      data-html="true"
                    ></i>
                  </span>
                </div>
                <div class="col-lg-4 col-md-5 col-sm-5 col-xs-4 p-0">
                  <select
                    class="form-control"
                    v-model="item.isOptional"
                    :disabled="!item.isVisible || item['requiredForDatavant']"
                    v-if="(item.key !== 'email' && item.key !== 'password' && item.key !== 'userName')"
                  >
                    <option value="default" disabled>Select Requirement</option>
                    <option value="optional">Optional field</option>
                    <option value="required">Required field</option>
                  </select>
                  <div v-if="item.isVisible && item.field === 'Birth Date'">
                    <label class="formate-class">Format:</label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="birthDate" class="radio-box" />
                      M/D/Y
                    </label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="dobWithMonthYear" class="radio-box" />
                      M/Y
                    </label>
                    <label class="formate-level">
                      <input type="radio" v-model="item.key" value="dobWithYear" class="radio-box" />
                      Y
                    </label>
                  </div>
                  <div class="optionalField" v-if="item.key === 'email' || item.key === 'password' || item.key === 'userName' || item.key === 'verificationPhone'">
                    <span v-if="item.isVisible" class="text-capitalize">{{ item.isOptional }} field</span>
                    <span v-else class="text-capitalize">Not Captured</span>
                  </div>
                </div>
              </div>
              <div class="row" v-if="item.key === 'gender'">
                <div class="custom-control custom-radio radio col-lg-11 p-0 col-lg-offset-1 col-md-11 col-md-offset-1 col-sm-12 col-xs-12 clearfix">
                  <input type="radio" name="gender" id="gender_standard" value="standard" class="custom-control-input" v-model="item.meta" :disabled="!item.isVisible" />
                  <label class="custom-control-label" for="gender_standard">Standard Gender Selection List</label>
                  <i
                    class="fa fa-info-circle help_icon cursor_pointer"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="0"
                    data-trigger="focus"
                    data-content="<b> Standard Gender Selection List </b><br />
                    • 	Male  <br />
                    • 	Female <br />
                    •   Other gender identity <br />&nbsp; &nbsp;(when selected, opens to a free form &nbsp;&nbsp;&nbsp;field)"
                    data-html="true"
                  ></i>
                </div>
                <div class="custom-control custom-radio radio col-lg-11 p-0 col-lg-offset-1 col-md-offset-1 col-md-11 col-sm-12 col-xs-12 clearfix">
                  <input type="radio" name="gender" id="gender_extended" value="extended" class="custom-control-input" v-model="item.meta" :disabled="!item.isVisible" />

                  <label class="custom-control-label" for="gender_extended">Expanded Gender Selection List</label>
                  <i
                    class="fa fa-info-circle help_icon cursor_pointer"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="1"
                    data-trigger="focus"
                    data-content="<b> Expanded Gender Selection List </b><br />
                        • 	Man <br />
                        • 	Woman <br />
                        • 	Genderqueer <br />
                        • 	Transgender Man (Female-to-Male) <br />
                        • 	Transgender Woman (Male-to- &nbsp;&nbsp;&nbsp;Female) <br />
                        • 	Another gender identity (when  &nbsp;&nbsp;&nbsp;selected, opens to a free form field)"
                    data-html="true"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-10">
          <span class="back_link" v-on:click="goBack()"> <i class="fa fa-chevron-left" aria-hidden="true"></i> Back </span>
        </div>
      </div>
      <div class="footerStyle">
        <div class="container">
          <div class="row" v-if="isStudySummary">
            <b-btn class="btn nextBtn float-left br-25" @click="cancelModify">Cancel modifying</b-btn>
            <b-btn class="btn br-25 disable-btn p-0 pt-5 mr-10" :to="{ name: 'study-summary', params: { studyId: studyId } }">Back to study summary</b-btn>
            <button class="btn br-25 continue-btn mr-10" v-on:click="nextClick()">
              Save and Continue
            </button>
          </div>
          <div class="row" v-if="!isStudySummary">
            <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">
              Skip for now
            </button>
            <button class="btn nextBtn br-25" v-on:click="nextClick()">
              Save and Continue
            </button>
          </div>
        </div>
      </div>
      <CancelModal ref="cancelConfirmation" />
    </div>
    <div class="modal fade scroll-custom" id="openCustomSelectCountries" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content">
          <div>
            <div class="select-countries-title">Select Countries</div>
            <button type="button" class="close" @click="closeCustomFieldModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="row border-row wrapper" id="scroll-custom-bar">
                <div v-for="(country, index) in countryList" class="col-md-6 pb-6" :key="index">
                  <lable v-if="!!customFieldArray && customFieldArray.length > 0">
                    <input v-model="customFieldArray[gIndex].expectedCountries" :value="country.countryId" type="checkbox" class="country-chk-box" />
                    <span class="country-name">{{ country.countryName }}</span>
                  </lable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="confirmDeleteCustomField" class="delete-custom-field-modal" hide-footer body-class="p-20">
      <div>
        <div class="modal-title text-center">
          <b
            ><p class="fs-20 mb-0">
              Are you sure you want to remove this custom field?
            </p></b
          >
        </div>
        <div class="pt-20 text-center">
          <p>
            Removing this field will delete it from the Participant App, affecting participant-facing screens.
          </p>
        </div>
        <b-col cols="12" class="text-center">
          <b-btn class="mt-20 mr-10 br-3 cancel-btn" size="md" variant="default" @click="$refs.confirmDeleteCustomField.hide()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 yes-btn" size="md" variant="primary" :disabled="false" @click="removeCustomFieldConfirmed">Yes</b-btn>
        </b-col>
      </div>
    </b-modal>
        <enabling-datavant-tokenization-modal ref="enablingDatavantTokenizationModal"
          @datavantModalEvent="openDatavantTokenListModal"
          @cancel-event="cancelEventHandler"/>
        <disabling-datavant-tokenization-modal ref="disablingDatavantTokenizationModal"
          :isDatavantTokenizationEnabled="this.isDatavantTokenizationEnabled"
          @cancel-event="cancelEventHandler"
          @disable-datavant-tokenization="enableDisableDatavantTokenization"/>
        <datavant-tokenization-modal
          ref="DatavantTokenizationModal"
          :datavantTokenDetails="datavantTokenList"
          @on-datavant-modal-close="closeDatavantTokenListModal( $event )"
          @selected-token-list="setSelectedDatavantTokenList($event)"
          @config-name="configName($event)"
          :configurationFileName="configurationFileName"
          :datasetName="datasetName"
          :isDatavantTokenEditable="isDatavantTokenEditable"/>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import toastr from "toastr";
import studyFeatureHeader from "../common/study-features-header";
import CancelModal from "./cancel-modify-modal";
import CustomFormSelect from "@/components/common/custom-form-select";
import { mapGetters } from "vuex";
import DatavantTokenizationModal from "../modals/datavant-tokenization-modal";
import * as DatavantService from '@/services/datavant-service';
import cloneDeep from 'lodash/cloneDeep';
import enablingDatavantTokenizationModal from "../modals/enabling-datavant-tokenization-modal"
import disablingDatavantTokenizationModal from "../modals/disabling-datavant-tokenization-modal"

export default {
  name: "credentials",
  data() {
    return {
      isDatavantTokenizationEnabled: false,
      selectedVerificationMethod: "email",
      studyId: null,
      careGiver: null,
      studyDetails: null,
      verificationOptions: [
        { id: "email", text: "Email Only" },
        { id: "phone", text: "Phone Only" },
        { id: "both", text: "Both (Email and Phone)" }
      ],
      isStudyOpenEnrollment: false,
      participantInfoData: [
        {
          field: "Participant's First Name",
          key: "firstName",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 1,
          position: 1,
          meta: ""
        },
        {
          field: "Participant's Last Name",
          key: "lastName",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 2,
          position: 3,
          meta: ""
        },
        {
          field: "Parent/Caregiver First Name",
          key: "parentOrCgFirstName",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 17,
          position: 5,
          meta: ""
        },
        {
          field: "Parent/Caregiver Last Name",
          key: "parentOrCgLastName",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 18,
          position: 7,
          meta: ""
        },
        {
          field: "Email",
          key: "email",
          isOptional: "required",
          isVisible: true,
          expectedValues: null,
          type: "personalInfo",
          index: 3,
          position: 9,
          meta: ""
        },
        {
          field: "Username",
          key: "userName",
          isOptional: "required",
          isVisible: true,
          type: "personalInfo",
          position: 10,
          index: 0,
          meta: "",
          expectedValues: null
        },
        {
          field: "Password",
          key: "password",
          isOptional: "required",
          isVisible: true,
          expectedValues: null,
          type: "personalInfo",
          index: 4,
          position: 10,
          meta: ""
        },
        {
          field: "Birth Date",
          key: "birthDate",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 5,
          position: 2,
          meta: ""
        },
        {
          field: "Age Range",
          key: "ageRange",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 6,
          position: 4,
          meta: ""
        },
        {
          field: "Primary Language",
          key: "language",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 7,
          position: 6,
          meta: ""
        },
        {
          field: "Gender",
          key: "gender",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 8,
          position: 8,
          meta: "standard"
        },
        {
          field: "Address",
          key: "address",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 9,
          position: 11,
          meta: ""
        },
        {
          field: "City / Town",
          key: "city",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 10,
          position: 13,
          meta: ""
        },
        {
          field: "State / Province / Region",
          key: "stateProvince",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 11,
          position: 15,
          meta: ""
        },
        {
          field: "Zip / Postal Code",
          key: "zipCode",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 12,
          position: 17,
          meta: ""
        },
        {
          field: "Country",
          key: "country",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 13,
          position: 12,
          meta: ""
        },
        {
          field: "Phone Number",
          key: "phoneNumber",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 14,
          position: 14,
          meta: ""
        },
        {
          field: "Non-Mobile Phone Number",
          key: "nonMobilePhoneNumber",
          isOptional: "optional",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 15,
          position: 16,
          meta: ""
        },
        {
          field: "How did you hear about this study?",
          key: "howDidYouHear",
          isOptional: "default",
          isVisible: false,
          expectedValues: null,
          type: "contactInfo",
          index: 16,
          position: 18,
          meta: ""
        },
        {
          field: "Verification Phone (Mobile)",
          key: "verificationPhone",
          isOptional: "Required field",
          isVisible: false,
          expectedValues: null,
          type: "personalInfo",
          index: 24,
          position: 24,
          meta: ""
        }
      ],
      isStudySummary: JSON.parse(window.localStorage.getItem("thread-studySummary")),
      participantCustomFieldArr: [],
      countryList: [],
      expectedCountries: [],
      gIndex: 0,
      isAddCustomFieldDisabled: false,
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      isMultiCountry: false,
      isCustomFiledsValid: false,
      customFieldName: "",
      datavantTokenList: [],
      configurationFileName: "",
      datasetName: "",
      datavantTokenizationPreviousState : null,
      datavantEnabledInStudy : false,
      isDatavantToggleEditable : true,
      isDatavantTokenEditable : true
    };
  },
  mounted() {
    this.isStudyOpenEnrollment = true;
    this.setInitialVerifyMethodPosition();
    window.setTimeout(() => {
      window.$('[data-toggle="popover"]').popover();
    }, 1);
    this.studyId = this.$route.params.studyId;
    this.participantInfoData = _.sortBy(this.participantInfoData, "position");
    this.getRegistration();
    this.getStudyDetail();
    this.startAutoSave();
    this.getStudyDataFact();
  },
  updated() {
    window.setTimeout(() => {
      window.$('[data-toggle="popover"]').popover();
    }, 1);
  },
  methods: {
    goBack() {
      window.history.back();
    },
    // TUR-61129 Start
    setFieldIndexOrder() {
      const order = ["userName", "password", "confirmPassword", "email", "verificationPhone", "firstName", "lastName", "birthDate", "ageRange", "gender", "language", "parentOrCgFirstName", "parentOrCgLastName", "address", "city", "stateProvince", "zipCode", "country", "nonMobilePhoneNumber", "phoneNumber", "howDidYouHear"];
      this.participantInfoData.forEach(item => {
        item.index = order.indexOf(item.key);
      });
    },
    setInitialVerifyMethodPosition() {
      const verificationMethodIndex = _.findIndex(this.participantInfoData, ["key", "verificationPhone"]);
      if (this.pwebCognitoAuthentication && this.pwebCognitoAuthentication === true) {
        this.participantInfoData[verificationMethodIndex].position = 10;
      } else {
        this.participantInfoData[verificationMethodIndex].position = 11;
      }
    },
    getStudyDataFact() {
      this.$api
        .getStudyDataFact(this.studyId)
        .then(res => {
          this.studyDetails = res.data;
          if (this.studyDetails.onboardingType !== "OpenEnrollment") {
            this.isStudyOpenEnrollment = false;
          }
          if (this.studyDetails.verificationMethod) {
            this.selectedVerificationMethod = this.studyDetails.verificationMethod;
          } else {
            this.selectedVerificationMethod = "email";
          }
          this.updateVerificationMethod(this.selectedVerificationMethod);
        })
        .catch(() => {
          this.$toastr.error("Error while getting the Study Data Fact");
        });
    },
    updateStudyDataFact(isDatavantTokenizationEnabled=false) {
      if(isDatavantTokenizationEnabled) {
          this.studyDetails.duringRegistrationConsentEnabled = true;
          this.studyDetails.consentEnabled = true;
          this.studyDetails.afterRegistrationConsentEnabled = false;
          this.studyDetails.noConsentToggle = false;
      }
      this.studyDetails['verificationMethod'] = this.selectedVerificationMethod;
      this.$api.updateNewStudyDataFact(this.studyDetails).then(res => {
        this.studyDetails = res.data; 
      }).catch(err => {
        this.$toastr.error("Error while updating Study Data Fact");       
      }) 
    },
    changeVerificationMethod(verficationMethod) {
      this.$api.getStudyActiveParticipantsWithVerificationMethod(this.studyId).then(result => {
        const status = {
          canBeMobile: !result.body.isEmail,
          canBeEmail: !result.body.isMobile
        };
        if (this.studyDetails.verificationMethod) {
          if (this.studyDetails.verificationMethod != "email" && this.selectedVerificationMethod == "email" && !status.canBeEmail) {
            this.selectedVerificationMethod = this.studyDetails.verificationMethod;
            this.$toastr.error("This Verification Method cannot be selected since existing participants are missing the selected verification data: Email. You may select Both (Email and Phone) as an interim option to collect the required verification data before making your final desired change.");
          } else if (this.studyDetails.verificationMethod != "phone" && this.selectedVerificationMethod == "phone" && !status.canBeMobile) {
            this.selectedVerificationMethod = this.studyDetails.verificationMethod;
            this.$toastr.error("This Verification Method cannot be selected since existing participants are missing the selected verification data: Verification Phone Number. You may select Both (Email and Phone) as an interim option to collect the required verification data before making your final desired change.");
          } else {
            this.updateVerificationMethod(verficationMethod);
          }
        } else {
          this.updateVerificationMethod(verficationMethod);
        }
      });
    },
    updateVerificationMethod(verficationMethod) {
      let phoneMethodIndex = null;
      let emailMethodIndex = null;
      phoneMethodIndex = _.findIndex(this.participantInfoData, ["key", "verificationPhone"]);
      emailMethodIndex = _.findIndex(this.participantInfoData, ["key", "email"]);
      const passwordFieldIndex = _.findIndex(this.participantInfoData, ["key", "password"]);
      const usernameFieldIndex = _.findIndex(this.participantInfoData, ["key", "userName"]);
      if (verficationMethod === "email") {
        this.participantInfoData[phoneMethodIndex].isVisible = false;
        this.participantInfoData[emailMethodIndex].isVisible = true;
      } else if (verficationMethod === "phone") {
        this.participantInfoData[phoneMethodIndex].isOptional = "required";
        this.participantInfoData[phoneMethodIndex].isVisible = true;
        this.participantInfoData[emailMethodIndex].isVisible = false;
      } else {
        this.participantInfoData[phoneMethodIndex].isVisible = true;
        this.participantInfoData[emailMethodIndex].isVisible = true;
      }
      if (this.pwebCognitoAuthentication) {
        this.participantInfoData[usernameFieldIndex].isOptional = "required";
        this.participantInfoData[usernameFieldIndex].isVisible = true;
        this.participantInfoData[passwordFieldIndex].isOptional = "required";
        this.participantInfoData[passwordFieldIndex].isVisible = true;
      } else {
        if (verficationMethod === "phone") {
          this.participantInfoData[passwordFieldIndex].isOptional = "Optional";
          this.participantInfoData[passwordFieldIndex].isVisible = false;
        } else {
          this.participantInfoData[passwordFieldIndex].isOptional = "required";
          this.participantInfoData[passwordFieldIndex].isVisible = true;
        }
      }
    },
    // TUR-61129 End
    changeVisibility(item) {
      let keyIndex = null;
      if (item.key !== "firstName" && item.key !== "lastName" && item.key !== "nonMobilePhoneNumber") {
        if (!item.isVisible) {
          keyIndex = _.findIndex(this.participantInfoData, ["key", item.key]);
          this.participantInfoData[keyIndex].isOptional = "default";
        }
      }
      if (item.isVisible) {
        if (item.key === "birthDate" || item.key === "dobWithMonthYear" || item.key === "dobWithYear") {
          keyIndex = _.findIndex(this.participantInfoData, ["key", "ageRange"]);
          this.participantInfoData[keyIndex].isVisible = false;
          this.participantInfoData[keyIndex].isOptional = "default";
        } else if (item.key === "ageRange") {
          keyIndex = _.findIndex(this.participantInfoData, ["field", "Birth Date"]);
          this.participantInfoData[keyIndex].isVisible = false;
          this.participantInfoData[keyIndex].isOptional = "default";
          this.participantInfoData[keyIndex].key = "birthDate";
        }
      } else {
        if (item.key === "birthDate" || item.key === "dobWithMonthYear" || item.key === "dobWithYear") {
          keyIndex = _.findIndex(this.participantInfoData, ["field", "Birth Date"]);
          this.participantInfoData[keyIndex].key = "birthDate";
        } else if (item.key === "ageRange") {
          keyIndex = _.findIndex(this.participantInfoData, ["field", "Birth Date"]);
          this.participantInfoData[keyIndex].key = "birthDate";
        }
      }
    },
    getRegistration() {
      const self = this;
      this.$api.getRegistrationFact(this.studyId).then(response => {
        if (response.body.participantRegistrationConfigDetails) {
          const phoneIndex = response.body.participantRegistrationConfigDetails.findIndex(item => item.key === "phone");
          if (phoneIndex > -1) {
            response.body.participantRegistrationConfigDetails.splice(phoneIndex, 1);
          }
          const item = response.body.participantRegistrationConfigDetails.find(item => item.key === "verificationPhone");
          if (item == null) {
            response.body.participantRegistrationConfigDetails.push({
              field: "Verification Phone (Mobile)",
              key: "verificationPhone",
              isOptional: "required",
              isVisible: false,
              expectedValues: null,
              type: "personalInfo",
              index: 19,
              position: 12,
              meta: ""
            });
          } else {
            item.field = "Verification Phone (Mobile)";
          }

          self.participantInfoData = response.body.participantRegistrationConfigDetails.filter(info => {
            if (info.key == "firstName") {
              info.field = "Participant's First Name";
            } else if (info.key == "lastName") {
              info.field = "Participant's Last Name";
            } else if (info.key == "email") {
              info.position = 9;
            } else if (info.key == "verificationPhone") {
              if (this.pwebCognitoAuthentication && this.pwebCognitoAuthentication === true) {
                info.position = 10;
              } else {
                info.position = 11;
              }
            } else if (info.key == "userName") {
              info.position = 10;
              if (this.pwebCognitoAuthentication && this.pwebCognitoAuthentication === true) {
                info.isOptional = "required";
                info.isVisible = true;
              } else {
                info.isOptional = "default";
                info.isVisible = false;
              }
            } else if (info.key == "password") {
              if (this.pwebCognitoAuthentication) {
                info.isOptional = "required";
                info.isVisible = true;
                info.position = 12;
              } else {
                info.position = 10;
              }
            } else if (info.key == "address" || info.key == "country" || info.key == "city" || info.key == "phoneNumber" || info.key == "stateProvince" || info.key == "nonMobilePhoneNumber" || info.key == "zipCode" || info.key == "howDidYouHear") {
              info.position = info.position + 2;
            }
            return info;
          });
          self.careGiver = _.find(self.participantInfoData, {
            key: "parentOrCgFirstName"
          });
          if (!self.careGiver) {
            self.participantInfoData.push({
              field: "Parent/Caregiver First Name",
              key: "parentOrCgFirstName",
              isOptional: "default",
              isVisible: false,
              expectedValues: null,
              type: "personalInfo",
              index: 17,
              position: 5,
              meta: ""
            });
            self.participantInfoData.push({
              field: "Parent/Caregiver Last Name",
              key: "parentOrCgLastName",
              isOptional: "default",
              isVisible: false,
              expectedValues: null,
              type: "personalInfo",
              index: 18,
              position: 7,
              meta: ""
            });
          }
          self.participantInfoData = _.sortBy(self.participantInfoData, "position");
        }
        this.setFieldIndexOrder();
        const verificationPhoneField = self.participantInfoData.find(i => i.key == "verificationPhone");
        if (verificationPhoneField) {
          verificationPhoneField.isOptional = "required";
        }
        this.updateVerificationMethod(this.selectedVerificationMethod);
        this.getDatavantToggleState();        
      });
    },
    nextClick(autoSave = false) {
      this.updateStudyDataFact();
      const isOptionalArray = _.filter(this.participantInfoData, o => o && o.isOptional === "default" && o.isVisible);

      if (this.isCustomFiledsValid) {
        toastr.error("Custom Field name is required.");
        return;
      }

      const payload = [...this.participantInfoData, ...this.participantCustomFieldArr];
      if (isOptionalArray.length === 0) {
        const regData = _.sortBy(payload, "index");
       /*  console.table("participant registration config details : ", regData); */
        this.$api
          .sendRegistrationDetailsFact(this.studyId, {
            participantRegistrationConfigDetails: regData
          })
          .then(
            () => {
              if (!autoSave) {
                const selectedFeatures = this.$store.getters.getSelectedFeatures;
                const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);
                if (featureIndex === selectedFeatures.length - 1) {
                  this.$router.push({ name: "features-library-final" });
                } else {
                  this.$router.push({
                    name: selectedFeatures[featureIndex + 1].route,
                    params: { studyId: this.studyId }
                  });
                }
              }
            },
            error => {
              if (!autoSave) {
                toastr.error(error.body && error.body.message ? error.body.message : "Error while sending the resgistration details");
              }
            }
          );
      } else {
        if (!autoSave) {
          toastr.error("Please select requirements for input fields or hide the ones that would not display.");
        }
      }
    },
    skipForNow() {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;
      const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);
      if (featureIndex === selectedFeatures.length - 1) {
        this.$router.push({ name: "features-library-final" });
      } else {
        this.$router.push({
          name: selectedFeatures[featureIndex + 1].route,
          params: { studyId: this.studyId }
        });
      }
    },
    cancelModify() {
      this.$refs.cancelConfirmation.show();
    },
    addCustomFiled() {
      let index = 19;
      let position = 19;
      let key = "regCustomField1";
      if (this.customFieldArray.length == 0) {
        index = 19;
        position = 19;
        key = "regCustomField1";
      }
      if (this.customFieldArray.length == 1) {
        index = 20;
        position = 20;
        key = "regCustomField2";
      }
      if (this.customFieldArray.length == 2) {
        index = 21;
        position = 21;
        key = "regCustomField3";
      }
      if (!!this.customFieldArray && this.customFieldArray.length > -1 && this.customFieldArray.length < 3) {
        const obj = {
          field: "",
          key: key,
          isOptional: "default",
          isVisible: true,
          type: "customfields",
          position: position,
          index: index,
          meta: "",
          expectedValues: null,
          expectedCountries: this.countryList.map(item => item.countryId)
        };
        this.participantInfoData.push(obj);
        // this.checkCustomFiledsArr();
        this.$forceUpdate();
      }
    },
    customFieldCountries(record, index) {
      this.gIndex = index;
      $("#openCustomSelectCountries").modal("show");
      this.participantCustomFieldArr.filter(item => {
        if (item.key === record.key) {
          this.expectedCountries = item.expectedCountries;
        }
      });
    },
    getStudyDetail() {
      this.$api.getStudyDataFact(this.studyId).then(response => {
        this.isMultiCountry = response.body.countryList.length > 1;
        this.countryList = response.body.countryList.filter(c => (c.isActive = true));
      });
    },
    insertIntoArray(arr, index, newItem) {
      return [...arr.slice(0, index), newItem, ...arr.slice(index)];
    },
    closeCustomFieldModal() {
      if (!!this.customFieldArray && this.customFieldArray[this.gIndex].expectedCountries.length < 1) {
        this.$toastr.warning("At least one country must be selected.");
      } else {
        $("#openCustomSelectCountries").modal("hide");
      }
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.nextClick(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    deleteCustomField(customFieldName) {
      this.participantInfoData = _.reject(this.participantInfoData, {
        key: customFieldName
      });
      this.$toastr.success("Custom field deleted successfully");
      this.isCustomFiledsValid = false;
      this.$refs.confirmDeleteCustomField.hide();
    },
    removeCustumField(customFieldName) {
      this.customFieldName = customFieldName;
      this.$refs.confirmDeleteCustomField.show();
    },
    removeCustomFieldConfirmed() {
      const params = {
        studyId: this.studyId,
        keyName: this.customFieldName
      };
      this.$api
      .canBeDeleteCustomField(params)
      .then((response) => {
        if (response.data.key === true) {
          this.$toastr.error("Custom field cannot be removed as data has already been collected for this field.");
        } else if (response.data.key === false) {
          this.deleteCustomField(this.customFieldName);
        }
      })
      .catch(() => {
        this.$toastr.error("Error in deleting custum field");
      })
    },
    getTokenList() {
      let params = {
        studyId: this.studyId
      }
      this.$api.getDatavantTokenList(params).then(res => {
        if (res && res.body) {
          this.datavantTokenList = res.body;

          if (this.datavantTokenizationPreviousState) {
            this.participantInfoData = DatavantService.tokenToFeildMapping(this.datavantTokenList, this.participantInfoData);
          }
        }
      },
        error => {
          this.$toastr.error(
            error.data && error.data.message
              ? error.data.message
              : "Error while getting token list."
          );
        });
    },
    async openDatavantTokenListModal() {
      if (!this.datavantTokenList.length) {
        this.getConfigName();
        await this.getTokenList();       
      }
      this.$refs.DatavantTokenizationModal.openModal();
    },
    resetParticipantInfo(deleteOnlyDatavantKey=false) {
      this.participantInfoData = this.participantInfoData.map( field => {
        /* this.studyDetails.verificationMethod ? '' */
        if ( !deleteOnlyDatavantKey && field.key !== 'password' && field.key !== 'email') {
          field.isOptional = "default";
          field.isVisible = false;
        }
        delete field.requiredForDatavant;
        delete field.disableForDatavant;
        return field;
      });
    },
    closeDatavantTokenListModal() {
      this.isDatavantTokenizationEnabled = _.clone(this.datavantTokenizationPreviousState);
      if(!this.datavantTokenizationPreviousState){
        this.resetParticipantInfo(true);
      }  
    },
    setSelectedDatavantTokenList( data ) {
      // Apply Tokens has been clicked from the Datavant TokenList Modal, So Enable datavant tokenization modal and update the status.
      this.datavantTokenList = data && data.tokenListData;
      this.enableDisableDatavantTokenization( true);   
      this.isDatavantTokenizationEnabled = data && data.isModalOpen;
      this.participantInfoData = DatavantService.tokenToFeildMapping( this.datavantTokenList, this.participantInfoData );
    },
    enableDisableDatavantTokenization(isEnabled) {
      let param = {
        studyId: this.studyId
      };
      
      let queryParam = {
        enabled: isEnabled
      };
      this.$api.updateDatavantToggleState( param, queryParam ).then( data => {
        this.datavantTokenizationPreviousState = isEnabled;
        if (isEnabled) {
          this.updateStudyDataFact(isEnabled)
        }
        else {
          toastr.success("Tokens reset.");
          this.resetParticipantInfo(true);
          this.datavantTokenList.forEach(token => {
            token.enabled = false;
          });
          this.configurationFileName = '';
          this.datasetName = '';
        }
        this.getDatavantToggleState();
      },
        error => {
          this.$toastr.error(
            error.data && error.data.message
              ? error.data.message
              : "Error while updating datavant toggle status."
          );
        });
    },
    getDatavantToggleState() {
      let param = {
        studyId: this.studyId
      };

      return this.$api.getDatavantToggleState( param ).then( data => {
        this.datavantEnabledInStudy = true;
        this.isDatavantTokenizationEnabled = data.body && data.body.dataVantStatus;
        this.isDatavantToggleEditable = data.body &&  data.body.isToggleEditable;
        this.isDatavantTokenEditable = data.body &&  data.body.isEditAllowed;
        this.datavantTokenizationPreviousState = data.body && data.body.dataVantStatus;
        if (this.isDatavantTokenizationEnabled) {
          this.getConfigName();
          this.getTokenList();
        }
      },
      error => {
        this.datavantEnabledInStudy = false;
      });
    },
    getConfigName() {
      let param = {
        studyId: this.studyId
      };
        this.$api.getConfigurationAndDataSetName(param).then (response => {
        this.configurationFileName = response.body.configurationFileName?response.body.configurationFileName : '';
        this.datasetName = response.body.datasetName?response.body.datasetName : '';
          },
              error => {
                    this.$toastr.error(
                        error.data && error.data.message
                            ? error.data.message
                            : "Error while getting Configuration Name and Data Set Name."
                );
          });
      },
    configName (data) {
    this.configurationFileName = data.configurationFileName;
    this.datasetName = data.datasetName;
    },
    cancelEventHandler(isEnabled) {
      this.isDatavantTokenizationEnabled = isEnabled;
    },
    toggleDatavantTokenization(){
      if ( this.isDatavantTokenizationEnabled ) 
      this.$refs.enablingDatavantTokenizationModal.show();
      else {
        this.$refs.disablingDatavantTokenizationModal.show();
      }
    }
 },
  components: { studyFeatureHeader, CancelModal, CustomFormSelect, DatavantTokenizationModal, enablingDatavantTokenizationModal, disablingDatavantTokenizationModal},
  computed: {
    ...mapGetters(["pwebCognitoAuthentication"]),
    totalParticpantInfo() {
      return this.participantInfoData.filter(participantInfo => participantInfo.type === "personalInfo").length;
    },
    personalInfoArray(){
      if(!!this.participantInfoData && this.participantInfoData.length > 0){
        return this.participantInfoData.filter(item => item && item.type === 'personalInfo')
      }      
    },
    customFieldArray(){
      if(!!this.participantInfoData && this.participantInfoData.length > 0){
        return this.participantInfoData.filter(item => item && item.type === 'customfields')
      }
      return [];
    },
    contactInfoArray(){
      if(!!this.participantInfoData && this.participantInfoData.length > 0){
        return this.participantInfoData.filter(item => item && item.type === 'contactInfo')
      }
      return [];
    },
    getCoreTokenCount() {
      return this.datavantTokenList.filter( token => token.tokenType && token.tokenType.toLowerCase() === "core" && token.enabled ).length;
    },
    getStandardTokenCount() {
      return this.datavantTokenList.filter( token => token.tokenType && token.tokenType.toLowerCase() === "standard" && token.enabled ).length;
    }
  },
  watch: {
    customFieldArray: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.isCustomFiledsValid = newValue.some(item => item.field === "" && item.isVisible === true);
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.nextClick(true);
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.delete-custom-field-modal {
  /deep/ .modal-header {
    padding: 5px 10px 0 16px;
    border-bottom: none;
  }
  p {
    font-size: 16px;
    color: #4a4a4a;
  }
  .btn {
    width: 150px;
    height: 45px;
    border-radius: 22px;
    border: none;
  }
  .cancel-btn {
    background-color: #e3e3e3;
    color: #4a4a4a;
  }
  .yes-btn {
    background-color: #4c8ce4;
    color: #fff;
  }
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }

  .col-lg-offset-1 {
    margin-left: 8.33333333%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.form-control {
  border: solid 2px #d3dfe4 !important;
  height: 40px !important;
}
button {
  cursor: pointer;
  border: none !important;
  outline: 0px solid !important;
}
.help_icon {
  color: #949496;
  border: none !important;
  outline: none !important;
}
.radio span {
  margin-right: 5px;
}
.custom-control .help_icon {
  right: -5px;
  position: relative;
  top: -5px;
}
.custom-control .custom-control-label {
  padding-left: 20px;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #fff;
  border-color: #48bf7a;
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #fff;
  border-color: rgba(72, 191, 122, 1);
  opacity: 0.5;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(/static/img/radio_dot.svg);
  width: 30px;
  height: 30px;
  top: -3px;
  left: -7px;
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::after {
  opacity: 0.5;
}
.verify_method select {
  width: 219px;
}
.passcode_icon {
  width: 15px;
  height: 15px;
}
button:focus {
  outline: 0px solid transparent;
}
.section_heading {
  font-size: 24px;
  clear: both;
  font-weight: bold;
  padding: 30px 0px 20px 0;
  color: #666669;
  text-transform: capitalize;
}
.section_heading p {
  color: #666669;
  opacity: 0.7;
}
.field_row {
  padding: 10px 0px;
}
.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.inactive {
  opacity: 0.5;
  pointer-events: none;
}
.header_text {
  color: #1d7fee;
  font-weight: bold;
  margin: 10px 0;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
}
.header_text {
  font-size: 16px;
  color: #1d7fee;
  font-weight: bold;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1.5px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.filds_section {
  border-radius: 8px;
  padding: 0 10px 10px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  min-height: 150px;
}
@media (max-width: 575px) {
  .switch {
    width: 50px;
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(12px);
    -ms-transform: translateX(12px);
    transform: translateX(12px);
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 25px;
    width: 25px;
    left: 12px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
  }
  .check_icon {
    color: rgb(46, 204, 113);
    position: absolute;
    left: 28px;
    top: 8px;
    font-size: 18px;
    transition: 0.4s;
  }
}

.optionalField {
  height: 40px;
}
.item_field_space {
  position: relative !important;
  left: 6px !important;
}
.token-details {
  display: inline-block;
  word-break: break-all;
  max-width: 100%;
}
.token-label {
  font-family: Roboto-bold;
  font-size: 12px;
}
.token-value{
  font-family: Roboto-Regular;
}
.pos_changed {
  position: relative;
  bottom: 90px !important;
}

.header_toped {
  position: relative;
  top: 90px !important;
}
.custom-field-input {
  width: 205px;
  height: 40px;
  margin: 0 9px 0 -42px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
}
.custom-field-margin {
  margin-left: 6px !important;
}
.custom-field-drop {
  width: 181px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
}
.custom-select-country {
  margin: 0px 0 0px 9px;
  padding: 5px 0px 0 0px;
  font-family: Roboto-Regular;
  font-size: 15px;
  font-weight: 500;
  color: #4c8ce4;
  cursor: pointer;
}
.add-custom-filed {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  color: #4c8ce4;
  background: #fff;
}
.custom-title {
  width: 129px;
  height: 32px;
  margin: 0 5px 8px 1px;
  font-family: Roboto-Regular;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
@media (min-width: 768px) {
  .modal-xl {
    width: 90%;
    max-width: 375px;
  }
}
.select-countries-title {
  font-size: 18px;
  font-weight: 500;
  color: #ccc;
  padding: 15px 18px 7px 22px;
}
.modal-content {
  width: 110% !important;
  height: 230px !important;
}
.country-name {
  margin: 17px 36px 1px 6px;
  font-family: Roboto-Regular;
  font-size: 16px;
  color: #000;
}
.country-chk-box {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  background-color: #1e8fe1;
}
.number-badge {
  width: 24px;
  height: 21px;
  display: flex;
  gap: 10px;
  margin: -20px 0px 0px 130px;
  padding: 0px 5px 0px 5px;
  border-radius: 4px;
  background-color: #e0e0e0;
}
.custom_icon_grey {
  color: #b5bcc0;
  font-size: 16px;
}

#select-Language {
  -moz-appearance: none !important;
  appearance: none;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}
#showVerificationMethod {
  background: #fff;
  position: absolute;
  top: 100%;
  width: 100% !important;
  height: fit-content;
  border-radius: 4px;
  overflow: auto;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}
#showVerificationMethod label {
  width: 100%;
  padding: 5px 10px;
  font-size: 14px;
  color: #000;
  display: flex;
  line-height: 30px;
  cursor: pointer;
  margin: 0;
}
#showVerificationMethod label:hover {
  background-color: #f5f8fa;
}
.formate-class {
  width: 195px;
  height: 20px;
  margin: 6px -140px 6px -216px;
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  text-align: left;
  color: #666669;
}
.radio-box {
  width: 21px;
  height: 14px;
  background-color: #4c8ce4;
}
.formate-level {
  opacity: 0.7;
  padding: 0px 57px 0px 6px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  color: #666669;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: transparent;
  opacity: 0.3;
}
.text-normalize {
  text-transform: none !important;
}
.sub-heading{
  padding-top: 16px;
  font-size: 14px;
  font-weight: normal;
  text-transform: none!important;
  color: #666669;;

}
.addCustomFiledBlur {
  opacity: 0.5;
}
.close {
  font-size: 32px;
  font-weight: 500;
  opacity: 0.5;
  margin: -38px 9px 21px 0px !important;
}
.row.border-row {
  border: solid red 1px;
  border: solid 2px lightgray;
  height: 150px;
  padding: 15px 0px 0px 0px;
  margin-top: -10px;
  border-radius: 3px;
}
.wrapper {
  overflow-y: scroll;
  //Scrollbar CSS for Mozilla
  scrollbar-color: #fff #fff; /* thumb and track color */
  scrollbar-width: thin;

  //Below is the scrollbar css for Chrome
  &::-webkit-scrollbar {
    width: 4px;
    height: 5px;
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d3dfe4;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}

.edit-datavant-token {
  color: #398dfc;
  cursor: pointer;
  font-family: Roboto-Regular;
  font-size: 14px;
  margin-left: 15px;
}
.standard-token {
  margin-left: 38px;
  font-family: Roboto-Regular;
  font-weight: 500;
  font-size: 14px;
}
.disabled-for-datavant {
  pointer-events: none;
  opacity: .5;
}
</style>
